import { isEVMChain } from '../../wallet/chains';
import { DEFAULT_CHAIN, DEFAULT_DAPP_STATE } from '../constants';
export function asAllChain(chain) {
    return chain;
}
export function getChainState(state, chain) {
    const key = asAllChain(chain);
    return state[key] ?? DEFAULT_DAPP_STATE[key] ?? DEFAULT_DAPP_STATE[DEFAULT_CHAIN];
}
export function patchChainState(prev, chain, patch) {
    const key = asAllChain(chain);
    return {
        ...prev,
        [key]: {
            ...getChainState(prev, chain),
            ...patch,
        },
    };
}
export const removeInvalidNFTs = (nfts) => {
    return nfts.filter((nft) => {
        return (nft.image &&
            nft.name &&
            nft.price &&
            nft.uri &&
            nft.tokenId != undefined &&
            nft.owner &&
            !nft.image.includes('https://res.cloudinary.com/dq4hz8khk'));
    });
};
export const checkEVMChainExists = (chainName) => {
    if (isEVMChain(chainName))
        return chainName;
    return undefined;
};
